import React, { FC, HTMLProps, ReactNode } from 'react';
import cx from 'clsx';

import { Footer } from './Footer';

import styles from './styles.module.scss';
import {Modals} from "./Modals";

type PageLayoutProps = HTMLProps<HTMLDivElement> & {
  header?: ReactNode;
  customMainClass?: string;
  hideFooter?: boolean;
  customBodyColor?: string;
  customFooterColor?: string;
  customFooterText?: string;
  isInvoiceMode?: boolean;
};

const PageLayout: FC<PageLayoutProps> = props => {
  const {
    children,
    className,
    customBodyColor,
    customFooterColor,
    customFooterText,
    customMainClass,
    header,
    hideFooter = false,
    isInvoiceMode,
    ...otherProps
  } = props;

  return (
    <div className={cx(styles.wrapper, className)} {...otherProps}>
      <Modals/>
      {header}

      {/*Browser reader mode functionality looks for the presence of the <main> element*/}
      <main
        role="main"
        className={cx(styles.main, customMainClass)}
        {...(!isInvoiceMode && { style: { backgroundColor: customBodyColor } })}
      >
        <div className={styles.mainBody}>
          {children}
        </div>
      </main>

      {!hideFooter && (
        <Footer
          customFooterColor={customFooterColor}
          customFooterText={customFooterText}
          isInvoiceMode={isInvoiceMode}
        />
      )}
    </div>
  );
};

export { PageLayout };
